export default "__VITE_ASSET__B9eFlr2X__"